module.exports = __webpack_public_path__ + "assets/9447853d6a2a283f458ad777fc679de7.mp3";